import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import logo from "../assets/logo.png";
import ROUTES from "../routes";

export default function NavBar() {
  const [navBarExpanded, setNavBarExpanded] = useState<boolean>(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  const handleNavClick: () => void = () => {
    setNavBarExpanded(false);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <Navbar
        expand="lg"
        style={{
          backgroundColor: scrolled ? "rgba(13,27,42,0.88)" : "#0d1b2a",
          backdropFilter: scrolled ? "blur(20px)" : "none",
          WebkitBackdropFilter: scrolled ? "blur(20px)" : "none",
          borderBottom: scrolled ? "1px solid rgba(109,199,68,0.12)" : "1px solid transparent",
          fontWeight: "400",
          transition: "background-color 0.3s ease, border-color 0.3s ease, backdrop-filter 0.3s ease",
        }}
        data-bs-theme="dark"
        expanded={navBarExpanded}
        sticky="top"
        className="custom-navbar"
      >
        <Container>
          <Navbar.Brand as={Link} to={ROUTES.HOME}>
            <img src={logo} alt="Logo" width={70} height={45} />
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setNavBarExpanded(!navBarExpanded)}
          />
          {/* Desktop Nav */}
          <Navbar.Collapse id="basic-navbar-nav" className="d-none d-lg-flex">
            <Nav className="mx-auto text-center w-100 d-lg-flex justify-content-lg-center">
              <Nav.Link as={Link} to={ROUTES.HOME} onClick={handleNavClick} className={isActive(ROUTES.HOME) ? "nav-link-active" : ""}>
                Home
              </Nav.Link>
              <NavDropdown title="Vendors" id="basic-nav-dropdown">
                <NavDropdown.Item
                  as={Link}
                  to={ROUTES.MEET_OUR_VENDORS}
                  onClick={handleNavClick}
                >
                  Meet our vendors
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to={ROUTES.MARKET_MAP}
                  onClick={handleNavClick}
                >
                  Market Map
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to={ROUTES.BECOME_A_VENDOR}
                  onClick={handleNavClick}
                >
                  Become a vendor
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to={ROUTES.BECOME_A_BUSKER}
                  onClick={handleNavClick}
                >
                  Become a Busker
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to={ROUTES.COMMUNITY_TABLE}
                  onClick={handleNavClick}
                >
                  Community Table
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link
                as={Link}
                to={ROUTES.RENTAL_SPACES}
                onClick={handleNavClick}
                className={isActive(ROUTES.RENTAL_SPACES) ? "nav-link-active" : ""}
              >
                Rental Spaces
              </Nav.Link>
              <Nav.Link
                as={Link}
                to={ROUTES.SEE_EVENTS}
                onClick={handleNavClick}
                className={isActive(ROUTES.SEE_EVENTS) ? "nav-link-active" : ""}
              >
                Events
              </Nav.Link>
              <Nav.Link
                as={Link}
                to={ROUTES.OUR_STORY}
                onClick={handleNavClick}
                className={isActive(ROUTES.OUR_STORY) ? "nav-link-active" : ""}
              >
                Our story
              </Nav.Link>
              <NavDropdown title="Support the Market" id="support-nav-dropdown">
                <NavDropdown.Item as={Link} to={ROUTES.BECOME_A_MEMBER} onClick={handleNavClick}>
                  Become a Member
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to={ROUTES.JOIN_THE_BOARD} onClick={handleNavClick}>
                  Join the Board
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to={ROUTES.SPONSORSHIP_PACKAGES} onClick={handleNavClick}>
                  Sponsorship Packages
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to={ROUTES.COMMUNITY_COLLABORATIONS} onClick={handleNavClick}>
                  Community Collaborations
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to={ROUTES.VOLUNTEER} onClick={handleNavClick}>
                  Volunteer with Us
                </NavDropdown.Item>
              </NavDropdown>
              <Nav.Link
                as={Link}
                to={ROUTES.CONTACT_US}
                onClick={handleNavClick}
                className={isActive(ROUTES.CONTACT_US) ? "nav-link-active" : ""}
              >
                Contact Us
              </Nav.Link>
              <Nav.Link as={Link} to={ROUTES.FAQ} onClick={handleNavClick} className={isActive(ROUTES.FAQ) ? "nav-link-active" : ""}>
                FAQ
              </Nav.Link>
              <Nav.Link
                as={Link}
                to={ROUTES.PLAN_VISIT}
                onClick={handleNavClick}
                className={isActive(ROUTES.PLAN_VISIT) ? "nav-link-active" : ""}
              >
                Plan your visit
              </Nav.Link>
            </Nav>
            <Link
              to={ROUTES.POLICIES}
              onClick={handleNavClick}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                background: isActive(ROUTES.POLICIES) ? "rgba(193,154,59,0.22)" : "rgba(193,154,59,0.1)",
                border: "1px solid rgba(193,154,59,0.4)",
                borderRadius: 999,
                padding: "0.38rem 1rem",
                color: "#C19A3B",
                fontSize: "0.82rem",
                fontWeight: 700,
                letterSpacing: "0.04em",
                textDecoration: "none",
                whiteSpace: "nowrap",
                marginRight: "0.4rem",
                transition: "background 0.2s, border-color 0.2s",
              }}
              onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.background = "rgba(193,154,59,0.22)"; (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(193,154,59,0.65)"; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.background = isActive(ROUTES.POLICIES) ? "rgba(193,154,59,0.22)" : "rgba(193,154,59,0.1)"; (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(193,154,59,0.4)"; }}
            >
              📋 Policies
            </Link>
            <Link
              to={ROUTES.NEWSLETTER}
              onClick={handleNavClick}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                background: isActive(ROUTES.NEWSLETTER) ? "rgba(109,199,68,0.2)" : "rgba(109,199,68,0.1)",
                border: "1px solid rgba(109,199,68,0.35)",
                borderRadius: 999,
                padding: "0.38rem 1rem",
                color: "#6dc744",
                fontSize: "0.82rem",
                fontWeight: 700,
                letterSpacing: "0.04em",
                textDecoration: "none",
                whiteSpace: "nowrap",
                marginRight: "0.5rem",
                transition: "background 0.2s, border-color 0.2s",
              }}
              onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.background = "rgba(109,199,68,0.22)"; (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(109,199,68,0.6)"; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.background = isActive(ROUTES.NEWSLETTER) ? "rgba(109,199,68,0.2)" : "rgba(109,199,68,0.1)"; (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(109,199,68,0.35)"; }}
            >
              📬 Newsletter
            </Link>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Mobile Sidebar */}
      <div
        className={`mobile-sidebar ${navBarExpanded ? "open" : ""}`}
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          height: "100vh",
          width: "80vw",
          maxWidth: "320px",
          background: "#0d1b2a",
          zIndex: 9999,
          transform: navBarExpanded ? "translateX(0)" : "translateX(100%)",
          transition: "transform 0.25s ease-in-out", // <-- use ease-in-out for smooth, no bounce
          boxShadow: navBarExpanded
            ? "-2px 0 16px rgba(26,66,9,0.18)"
            : "none",
          display: "flex",
          flexDirection: "column",
          padding: "2rem 1.2rem 1.2rem 1.2rem",
        }}
      >
        <button
          style={{
            background: "none",
            border: "none",
            color: "#fff",
            fontSize: "2rem",
            position: "absolute",
            top: "18px",
            left: "18px", // <-- changed from right to left
            cursor: "pointer",
            zIndex: 10001,
          }}
          aria-label="Close menu"
          onClick={() => setNavBarExpanded(false)}
        >
          &times;
        </button>
        <Nav
          className="flex-column"
          style={{ marginTop: "2.5rem", gap: "1rem" }}
        >
          <Nav.Link as={Link} to={ROUTES.HOME} onClick={handleNavClick}>
            Home
          </Nav.Link>
          <NavDropdown title="Vendors" id="mobile-nav-dropdown">
            <NavDropdown.Item
              as={Link}
              to={ROUTES.MEET_OUR_VENDORS}
              onClick={handleNavClick}
            >
              Meet our vendors
            </NavDropdown.Item>
            <NavDropdown.Item
              as={Link}
              to={ROUTES.BECOME_A_VENDOR}
              onClick={handleNavClick}
            >
              Become a vendor
            </NavDropdown.Item>
            <NavDropdown.Item
              as={Link}
              to={ROUTES.BECOME_A_BUSKER}
              onClick={handleNavClick}
            >
              Become a Busker
            </NavDropdown.Item>
            <NavDropdown.Item
              as={Link}
              to={ROUTES.COMMUNITY_TABLE}
              onClick={handleNavClick}
            >
              Community Table
            </NavDropdown.Item>
            <NavDropdown.Item
              as={Link}
              to={ROUTES.MARKET_MAP}
              onClick={handleNavClick}
            >
              Market Map
            </NavDropdown.Item>
          </NavDropdown>
          <Nav.Link
            as={Link}
            to={ROUTES.RENTAL_SPACES}
            onClick={handleNavClick}
          >
            Rental Spaces
          </Nav.Link>
          <Nav.Link as={Link} to={ROUTES.SEE_EVENTS} onClick={handleNavClick}>
            Events
          </Nav.Link>
          <Nav.Link as={Link} to={ROUTES.OUR_STORY} onClick={handleNavClick}>
            Our story
          </Nav.Link>
          <NavDropdown title="Support the Market" id="mobile-support-nav-dropdown">
            <NavDropdown.Item as={Link} to={ROUTES.BECOME_A_MEMBER} onClick={handleNavClick}>
              Become a Member
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to={ROUTES.JOIN_THE_BOARD} onClick={handleNavClick}>
              Join the Board
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to={ROUTES.SPONSORSHIP_PACKAGES} onClick={handleNavClick}>
              Sponsorship Packages
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to={ROUTES.COMMUNITY_COLLABORATIONS} onClick={handleNavClick}>
              Community Collaborations
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to={ROUTES.VOLUNTEER} onClick={handleNavClick}>
              Volunteer with Us
            </NavDropdown.Item>
          </NavDropdown>
          <Nav.Link as={Link} to={ROUTES.CONTACT_US} onClick={handleNavClick}>
            Contact Us
          </Nav.Link>
          <Nav.Link as={Link} to={ROUTES.FAQ} onClick={handleNavClick}>
            FAQ
          </Nav.Link>
          <Nav.Link as={Link} to={ROUTES.PLAN_VISIT} onClick={handleNavClick}>
            Plan your visit
          </Nav.Link>
        </Nav>
        <div style={{ display: "flex", flexDirection: "column", gap: "0.65rem", marginTop: "1.25rem" }}>
          <Link
            to={ROUTES.POLICIES}
            onClick={handleNavClick}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 7,
              background: "rgba(193,154,59,0.1)",
              border: "1px solid rgba(193,154,59,0.4)",
              borderRadius: 999,
              padding: "0.55rem 1.2rem",
              color: "#C19A3B",
              fontSize: "0.9rem",
              fontWeight: 700,
              textDecoration: "none",
              alignSelf: "flex-start",
            }}
          >
            📋 Policies
          </Link>
          <Link
            to={ROUTES.NEWSLETTER}
            onClick={handleNavClick}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 7,
              background: "rgba(109,199,68,0.1)",
              border: "1px solid rgba(109,199,68,0.35)",
              borderRadius: 999,
              padding: "0.55rem 1.2rem",
              color: "#6dc744",
              fontSize: "0.9rem",
              fontWeight: 700,
              textDecoration: "none",
              alignSelf: "flex-start",
            }}
          >
            📬 Newsletter
          </Link>
        </div>
      </div>
      {/* Overlay for sidebar */}
      {navBarExpanded && (
        <div
          onClick={() => setNavBarExpanded(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(26,66,9,0.25)",
            zIndex: 9998,
          }}
        />
      )}
      {/* Sidebar styles */}
      <style>
        {`
          .nav-link-active {
            color: #6dc744 !important;
            position: relative;
          }
          .nav-link-active::after {
            content: '';
            position: absolute;
            bottom: 2px;
            left: 50%;
            transform: translateX(-50%);
            width: 18px;
            height: 2px;
            background: #6dc744;
            border-radius: 999px;
          }
          @media (max-width: 991px) {
            .custom-navbar .navbar-collapse {
              display: none !important;
            }
            .mobile-sidebar {
              display: flex !important;
            }
            .mobile-sidebar .nav-link,
            .mobile-sidebar .dropdown-item {
              color: white !important;
            }
            .mobile-sidebar .nav-link:hover,
            .mobile-sidebar .dropdown-item:hover {
              color: #6dc744 !important;
            }
            .mobile-sidebar .dropdown-toggle {
              color: white !important;
            }
            .mobile-sidebar .dropdown-toggle:hover,
            .mobile-sidebar .dropdown-toggle:focus {
              color: #6dc744 !important;
            }

            .mobile-sidebar .dropdown-menu {
              background-color: #ffffff !important;
              border: none;
            }

            .mobile-sidebar .dropdown-menu .dropdown-item {
              color: #0d1b2a !important;
            }

            .mobile-sidebar .dropdown-menu .dropdown-item:hover,
            .mobile-sidebar .dropdown-menu .dropdown-item:focus {
              background-color: #f0f4f8 !important;
              color: #0d1b2a !important;
            }
          }
          @media (min-width: 992px) {
            .mobile-sidebar {
              display: none !important;
            }
          }
        `}
      </style>
    </>
  );
}
